"use client";

import clsx from "clsx";

export type Timeframe = "7D" | "30D" | "90D" | "1Y" | "ALL";

interface TimeframeSelectorProps {
  value: Timeframe;
  onChange: (timeframe: Timeframe) => void;
}

const timeframes: Timeframe[] = ["7D", "30D", "90D", "1Y", "ALL"];

export const TimeframeSelector = ({ value, onChange }: TimeframeSelectorProps) => {
  return (
    <div className="flex gap-1 rounded-lg bg-slate-800 p-1">
      {timeframes.map((tf) => (
        <button
          key={tf}
          onClick={() => onChange(tf)}
          className={clsx(
            "rounded-md px-3 py-1 text-xs font-medium transition",
            value === tf ? "bg-slate-700 text-white" : "text-slate-400 hover:text-white"
          )}
        >
          {tf}
        </button>
      ))}
    </div>
  );
};
